(() => {
 const bind = () => {
  const menu = document.querySelector('.bb-navigation');
  if (!menu || menu.dataset.bbBound) return;
  menu.dataset.bbBound = 'true';
  const media = matchMedia('(min-width:1001px)');
  const adapt = () => {menu.open = media.matches;menu.querySelectorAll('.bb-nav-group').forEach(group => {group.open = media.matches;});};
  adapt();media.addEventListener('change',adapt);
  const shell = menu.closest('.bb-menu-shell');
  const positionBackdrop = () => {if(shell) shell.style.setProperty('--bb-backdrop-top',Math.max(0,shell.getBoundingClientRect().bottom)+'px');};
  positionBackdrop();window.addEventListener('resize',positionBackdrop);window.addEventListener('scroll',positionBackdrop,{passive:true});
  menu.addEventListener('click',event => {const close = event.target.closest('[data-bb-menu-close]');if(!close) return;const panel=close.closest('.bb-mega');if(panel){panel.open=false;panel.querySelector('summary')?.focus();}});
  menu.querySelectorAll('.bb-mega').forEach(panel => panel.addEventListener('toggle', () => {
   positionBackdrop();
   if (panel.open && media.matches) panel.querySelectorAll('.bb-nav-group').forEach(group => {group.open = true;});
   if (panel.open) menu.querySelectorAll('.bb-mega').forEach(other => {if (other !== panel) other.open = false;});
  }));
  document.addEventListener('click', event => {if (!menu.contains(event.target)) menu.querySelectorAll('.bb-mega').forEach(panel => {panel.open = false;});});
  document.addEventListener('keydown', event => {
   if (event.key !== 'Escape') return;
   const activePanel = [...menu.querySelectorAll('.bb-mega[open]')].find(panel => panel.contains(document.activeElement));
   activePanel?.querySelector('summary')?.focus();
   menu.querySelectorAll('details[open]').forEach(detail => {detail.open = false;});
   if (!media.matches) {menu.open = false;menu.querySelector('summary')?.focus();}
  });
 };
 bind();document.addEventListener('shopify:section:load',bind);
})();
